// product page icon with text horizontal scroll for mobile 
function enableAutoScroll() {
  const sliders = document.querySelectorAll(
    '.product .icon-with-text, .product .metafield-icon-with-text'
  );

  sliders.forEach((slider) => {
    // Run only if 4 or more items
    if (slider.children.length < 4) return;

    if (!slider.classList.contains('auto-scroll-ready')) {
      slider.classList.add('auto-scroll-ready');

      const originalChildren = Array.from(slider.children);
      originalChildren.forEach((child, index) => {
        const clone = child.cloneNode(true);
        if (index === 0) clone.classList.add('first-clone');
        slider.appendChild(clone);
      });
    }

    let speed = 0.5;
    let isPaused = false;
    let isDown = false;
    let lastX;
    let currentScroll = slider.scrollLeft;
    let loopWidth = 0;

    function animate() {
      if (!loopWidth) {
        const firstClone = slider.querySelector('.first-clone');
        if (firstClone && slider.firstElementChild) {
          loopWidth =
            firstClone.offsetLeft - slider.firstElementChild.offsetLeft;
        }
      }

      if (!isPaused && !isDown && loopWidth > 0) {
        currentScroll += speed;

        if (currentScroll >= loopWidth) {
          currentScroll -= loopWidth;
        } else if (currentScroll < 0) {
          currentScroll += loopWidth;
        }

        slider.scrollLeft = currentScroll;
      }

      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);

    slider.addEventListener(
      'scroll',
      () => {
        if (!isDown && isPaused) {
          currentScroll = slider.scrollLeft;
        }
      },
      { passive: true }
    );

    function startDrag(e) {
      isDown = true;
      isPaused = true;
      lastX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
      slider.style.cursor = 'grabbing';
    }

    function stopDrag() {
      isDown = false;
      isPaused = false;
      slider.style.cursor = 'grab';
    }

    function moveDrag(e) {
      if (!isDown) return;
      if (e.type.includes('mouse')) e.preventDefault();

      const x = e.type.includes('mouse')
        ? e.pageX
        : e.touches[0].pageX;

      const walk = (x - lastX) * 1.5;
      lastX = x;

      currentScroll -= walk;

      if (loopWidth > 0) {
        if (currentScroll >= loopWidth) {
          currentScroll -= loopWidth;
        } else if (currentScroll < 0) {
          currentScroll += loopWidth;
        }
      }

      slider.scrollLeft = currentScroll;
    }

    // Mouse Events
    slider.addEventListener('mousedown', startDrag);
    slider.addEventListener('mouseup', stopDrag);
    slider.addEventListener('mouseleave', stopDrag);
    slider.addEventListener('mousemove', moveDrag);

    // Touch Events
    slider.addEventListener('touchstart', startDrag, { passive: true });
    slider.addEventListener('touchend', stopDrag);
    slider.addEventListener('touchcancel', stopDrag);
    slider.addEventListener('touchmove', moveDrag, { passive: true });

    slider.style.cursor = 'grab';
  });
}

document.addEventListener('DOMContentLoaded', enableAutoScroll);
// product page icon with text horizontal scroll for mobile 


// ✅ Delegated click handling
document.addEventListener('click', function (event) {
  const optionBox = event.target.closest('.block__cart-drawer-selling-option-box');
  if (optionBox) {
    event.preventDefault();
    const ul = optionBox.querySelector('ul');
    if (ul) {
      ul.style.display = (ul.style.display === 'none' || ul.style.display === '') ? 'block' : 'none';
    }
  }

  // Plan selection
  const selectedItem = event.target.closest('.block__cart-drawer-selling-option-box ul li');
  if (selectedItem) {
    event.preventDefault();
    event.stopPropagation();

    const ul = selectedItem.closest('ul');
    if (!ul) return;

    ul.querySelectorAll('li').forEach(item => item.classList.remove('active'));
    selectedItem.classList.add('active');

    const selectedText = selectedItem.textContent;
    const displayParagraph = selectedItem.closest('.block__cart-drawer-selling-option-box')?.querySelector('p');
    if (displayParagraph) displayParagraph.innerHTML = selectedText;


    const cartItemSellingPlanID = selectedItem.getAttribute('data-value');
    const cartItem = selectedItem.closest('.cart-item');

    if (!cartItem) return;

    const itemSellingPlanName = cartItem.querySelector('.selling_plan_name');
    itemSellingPlanName.innerHTML = selectedText;
    const cartItemIndex = cartItem.getAttribute('item-data-index');
    const quantityInput = cartItem.querySelector('.quantity__input');
    const cartItemQty = quantityInput ? quantityInput.value : 1;

    updateSellingPlan(cartItemSellingPlanID, cartItemIndex, cartItemQty);
  }

  // Toggle subscribe
  const toggleButton = event.target.closest('.block__cart-drawer-selling-plan-toggle');
  if (toggleButton) {
    event.preventDefault();
    event.stopPropagation();
    toggleButton.classList.toggle("subscribe");

    const cartItem = toggleButton.closest('.cart-item');
    if (!cartItem) return;

    const cartItemIndex = cartItem.getAttribute("item-data-index");
    const quantityInput = cartItem.querySelector('.quantity__input');
    const cartItemQty = quantityInput ? quantityInput.value : 1;

    let cartItemSellingPlanID = '';
    const planBox = cartItem.querySelector('.block__cart-drawer-selling-option-box');

    if (toggleButton.classList.contains("subscribe")) {
      const activeItem = planBox?.querySelector('li.active') || planBox?.querySelector('li:first-child');
      if (activeItem) {
        cartItemSellingPlanID = activeItem.getAttribute("data-value");
      }
    }

    updateSellingPlan(cartItemSellingPlanID, cartItemIndex, cartItemQty);

    // ✅ Wait 2 seconds, then refresh the cart drawer via AJAX
    setTimeout(() => {

      if (typeof updateCart === 'function') {
        refreshCartDrawer();
        if (window.Rebuy?.init) {
          window.Rebuy.init();
        }
      } else {
        console.warn('⚠️ updateCart() is not defined.');
      }
    }, 2000);
  }
});

// ✅ Selling plan updater
function updateSellingPlan(cartItemSellingPlanID, cartItemIndex, cartItemQty) {
  if (!cartItemIndex || isNaN(parseInt(cartItemQty))) {
    console.error("❌ Missing cart item index or quantity", { cartItemIndex, cartItemQty });
    return;
  }

  const formData = {
    line: parseInt(cartItemIndex),
    quantity: parseInt(cartItemQty),
    selling_plan: cartItemSellingPlanID || null,
  };

  fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => response.json())
    .then(data => {
    })
    .catch(error => {
      console.error('❌ Error updating selling plan:', error);
    });
}

// product subscription JS
function initRechargePricing(scope = document) {

  const wrapper = scope.querySelector('.block__product-recharge');
  const oneTimePriceBox = wrapper?.querySelector('.onetime .block_product-grid_subscribe-price');
  const subscribePriceBox = wrapper?.querySelector('.subscription .block_product-grid_subscribe-price');

  const oneTimeRadio = wrapper?.querySelector('input[value="one-time"]');
  const subscribeRadio = wrapper?.querySelector('input[value="subscribe"]');

  function updatePrices(qtyInput, dropdown, oneTimePriceBox, subscribePriceBox) {
    const qty = parseInt(qtyInput.value) || 1;

    const baseOneTime = parseFloat(oneTimePriceBox?.dataset.price || 0);
    const totalOneTimePrice = Shopify.formatMoney(baseOneTime * qty);

    if (oneTimePriceBox) {
      oneTimePriceBox.innerText = totalOneTimePrice;
    }

    let baseSubscribe = 0;

    if (dropdown) {
      const selectedOption = dropdown.options[dropdown.selectedIndex];
      baseSubscribe = parseFloat(selectedOption?.dataset.price || 0);
    } else {
      baseSubscribe = parseFloat(subscribePriceBox?.dataset.price || 0);
    }

    const totalSubscribePrice = Shopify.formatMoney(baseSubscribe * qty);

    if (subscribePriceBox) {
      subscribePriceBox.innerHTML = `${totalSubscribePrice} <del>${totalOneTimePrice}</del>`;
    }
  }

  if (oneTimeRadio && subscribeRadio && !wrapper.dataset.rechargeInit) {

    wrapper.dataset.rechargeInit = 'true';

    oneTimeRadio.addEventListener('change', function () {
      scope.querySelectorAll('.product__buy-box').forEach(box => {
        const dropdown = box.querySelector('.selling_plan_dropdown');
        const hiddenInput = box.querySelector('.block__product-card-subscription-val');

        if (dropdown) dropdown.style.display = 'none';
        if (hiddenInput) hiddenInput.value = '';

        box.querySelectorAll('.quantity__input').forEach(input => {
          input.dispatchEvent(new Event('change'));
        });
      });
    });

    subscribeRadio.addEventListener('change', function () {
      scope.querySelectorAll('.product__buy-box').forEach(box => {
        const dropdown = box.querySelector('.selling_plan_dropdown');
        const hiddenInput = box.querySelector('.block__product-card-subscription-val');

        if (dropdown) {
          dropdown.style.display = 'block';
          if (hiddenInput) hiddenInput.value = dropdown.value;
        }

        box.querySelectorAll('.quantity__input').forEach(input => {
          input.dispatchEvent(new Event('change'));
        });
      });
    });
  }

  const buyBoxes = scope.querySelectorAll('.product__buy-box');

  buyBoxes.forEach(box => {

    if (box.dataset.rechargeInit) return;
    box.dataset.rechargeInit = 'true';

    const qtyInput = box.querySelector('.quantity__input');
    const buttons = box.querySelectorAll('.quantity__button');
    const dropdown = box.querySelector('.selling_plan_dropdown');
    const hiddenInput = box.querySelector('.block__product-card-subscription-val');

    const productContainer = box.closest('.product') || box.parentElement;

    const boxOneTimePriceBox =
      productContainer?.querySelector('.onetime .block_product-grid_subscribe-price') ||
      oneTimePriceBox;

    const boxSubscribePriceBox =
      productContainer?.querySelector('.subscription .block_product-grid_subscribe-price') ||
      subscribePriceBox;

    if (dropdown) {
      dropdown.style.display = 'none';
    }

    if (!qtyInput) return;

    function updateAllPrices() {

      updatePrices(
        qtyInput,
        dropdown,
        boxOneTimePriceBox,
        boxSubscribePriceBox
      );

      const priceEl = productContainer?.querySelector('.qtybased_price .main_price');
      const priceCl = productContainer?.querySelector('.qtybased_price .p-price-item--compare');
      const setFor = productContainer?.querySelector('.qtybased_price .setfor');
      let basePrice = priceEl ? parseInt(priceEl.dataset.price) : 0;
      let comparePrice = priceCl ? parseInt(priceCl.dataset.compareprice) : 0;

      const qty = parseInt(qtyInput.value) || 1;

      let currentPrice = basePrice;

      if (subscribeRadio?.checked && dropdown) {
        const selectedOption = dropdown.options[dropdown.selectedIndex];
        currentPrice = parseFloat(selectedOption?.dataset.price || basePrice);
      }

      if (priceEl) {
        priceEl.innerText = Shopify.formatMoney(currentPrice * qty);
      }

      if (priceCl) {
        priceCl.innerText = Shopify.formatMoney(comparePrice * qty);
      }

      if (setFor) {
        setFor.innerText = qty;
      }
    }

    if (dropdown) {
      dropdown.addEventListener('change', function () {
        if (hiddenInput) hiddenInput.value = this.value;
        updateAllPrices();
      });
    }

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        setTimeout(updateAllPrices, 150);
      });
    });

    qtyInput.addEventListener('input', updateAllPrices);
    qtyInput.addEventListener('change', updateAllPrices);

    updateAllPrices();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initRechargePricing();
});

// prop65 warning icon hover js for product page
// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".prop65-warning").forEach((wrapper) => {
//     const trigger = wrapper.querySelector(".prop65-trigger .product__tooltip-info");
//     const content = wrapper.querySelector(".prop65-content");
//     if (!trigger || !content) return;
//     trigger.addEventListener("mouseenter", () => {
//       content.style.display = "block";
//     });
//     trigger.addEventListener("mouseleave", () => {
//       content.style.display = "none";
//     });
//     trigger.addEventListener("click", () => {
//       content.style.display =
//         content.style.display === "block" ? "none" : "block";
//     });
//   });
// });


document.addEventListener('click', async function (event) {
  const checkoutButton = event.target.closest(
    'button[name="checkout"], input[name="checkout"], a[href="/checkout"]'
  );

  if (!checkoutButton) return;

  event.preventDefault();

  const checkoutUrl =
    checkoutButton.closest('a')?.href ||
    checkoutButton.href ||
    '/checkout';

  try {
    const cart = await fetch('/cart.js').then(res => res.json());

    await Promise.all(
      cart.items.map(async (item) => {
        const product = await fetch(`/products/${item.handle}.js`).then((res) =>
          res.json()
        );

        if (product.tags.includes('Perishable')) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties: {
                ...(item.properties || {}),
                _Perishable: 'true'
              }
            })
          });
        }
      })
    );

    console.log('Perishable property update completed successfully.');
  } catch (error) {
    console.error('Perishable property update failed:', error);
  } finally {
    window.location.assign(checkoutUrl);
  }
});